import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'pbc-enquiry',
  templateUrl: './enquiry.component.html',
})
export class EnquiryComponent implements OnInit {

  enquiryForm: FormGroup;

  @Input() visible: boolean;

  constructor() {
    this.visible = false;
    this.enquiryForm = new FormGroup({
      'firstNameLastName' : new FormControl(''),
      'email' : new FormControl('', [Validators.required, Validators.email]),
      'message' : new FormControl(''),
      'phone' : new FormControl(''),
      'sendCopy' : new FormControl(false),
      'agreement' : new FormControl(false, Validators.requiredTrue)
    });
  }

  closeWindow() {
    this.visible = false;
    this.enquiryForm.controls['firstNameLastName'].setValue("");
    this.enquiryForm.controls['email'].setValue("");
    this.enquiryForm.controls['message'].setValue("");
    this.enquiryForm.controls['phone'].setValue("");

    this.enquiryForm.controls['sendCopy'].setValue(false);
    this.enquiryForm.controls['agreement'].setValue(false);

    this.enquiryForm.markAsPristine({});
    this.enquiryForm.markAsUntouched({});
  }

  ngOnInit() {
  }
}
